module.exports = __webpack_public_path__ + "img/erweima.ad028d2f.png";